<ng-container *ngIf="showDownloadPdfButton; else noButton">
	<ac-nav-header [appName]="'ALLOCATION & INSIGHTS' | dcr : 'MB_FAMILY_ADVANCED_VIEW_TITLE'" gridClass="" [shouldOverridePadding]="false" [customContentClass]="navHeaderClass">
		<ng-template>
			<header-menu-item
				icon="file-pdf"
				[linkEvent]="tealiumConstants.MODELS_EXPERIENCE_EVENTS.MODELS_EXPERIENCE_APP_NAME + 'header:header clicks:generate report'"
				(onMenuItemClick)="generateAdvisorReport()"
			>
				<span class="generate-pdf" dcrHTMLKey="GENERATE_REPORT_TITLE">
					Generate PDF
					<new-feature featureKey="NEW_DOWNLOAD_PDF" [topOffset]="60" [leftOffset]="30"></new-feature>
				</span>
			</header-menu-item>
		</ng-template>
		<ng-template>
			<header-menu-item
				[hidden]="!showDownloadHoldings"
				icon="file-excel"
				[linkEvent]="tealiumConstants.MODELS_EXPERIENCE_EVENTS.MODELS_EXPERIENCE_APP_NAME + 'header:header clicks:download holdings'"
				(onMenuItemClick)="onDownloadHoldingsClick()"
			>
				<span dcrHTMLKey="MENU_DOWNLOAD_HOLDINGS_DETAILS_PAGE">Download Holdings</span>
			</header-menu-item>
		</ng-template>
	</ac-nav-header>
</ng-container>

<ng-template #noButton>
	<ac-nav-header [appName]="'ALLOCATION & INSIGHTS' | dcr : 'MB_FAMILY_ADVANCED_VIEW_TITLE'" gridClass=""> </ac-nav-header>
</ng-template>

<ac-notifications channel="browser"></ac-notifications>

<!-- Tabbed Component here and pass the tab Ids-->
<section class="grid text-align-left">
	<div class="margin-standard">
		<a
			[routerLink]="[backToAvailableModelsRouterLink]"
			[queryParams]="{ familyId: null, groupId: null, subType: null, userFilterName }"
			queryParamsHandling="merge"
			class="text-14-bold"
			custom-tracking
			[track-event]="tealiumConstants.MODELS_EXPERIENCE_EVENTS.MODELS_EXPERIENCE_APP_NAME + ':family details:back to available models'"
			data-cy="back-to-family-list"
		>
			<icon class="margin-right-10" type="chevron-left"></icon>
			<span dcrHTMLKey="MODELS_OVERVIEW_BACK">Back to Available Models</span>
		</a>
	</div>

	<div data-cy="family-name-title" class="text-28 text-bold padding-bottom-8 padding-adjust">
		{{ modelExternalName ? modelExternalName : familyName }} {{ modelSubscriptLabel }}
	</div>
	<ac-disclosure [isExpandable]="false" class="dz-block dz-hidden-lg padding-bottom-8 padding-adjust" dcrKey="ME_PERFORMANCE_DETAILS_TABLET_DISCLOSURE"></ac-disclosure>
	<dz-tabs type="scrollable">
		<ng-container *ngFor="let tab of visibleDetailsTabs">
			<dz-tab-panel [route]="tab.route" [title]="tab.label?.dcrValue"></dz-tab-panel>
		</ng-container>
	</dz-tabs>
	<router-outlet></router-outlet>
	<div class="margin-top-16">
		<ac-disclosure dcrKey="ME_FAMILY_DETAILS_DISCLOSURE"></ac-disclosure>
	</div>
</section>
